
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/self-assessment",
      function () {
        return require("private-next-pages/self-assessment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/self-assessment"])
      });
    }
  